var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Chip as MuiChip } from '@mui/material';
import { getAttributes } from '../../../utils';
import { ChipHtmlTags } from './types';
var C = function (_a) {
    var props = __rest(_a, []);
    var label = props.label, color = props.color, borderColor = props.borderColor, background = props.background, id = props.id, className = props.className, _b = props.component, component = _b === void 0 ? ChipHtmlTags.Span.toLowerCase() : _b, rest = __rest(props, ["label", "color", "borderColor", "background", "id", "className", "component"]);
    var muiConfigC = __assign({ label: label, component: component.toLowerCase(), id: id, sx: {
            background: background,
            outlineColor: borderColor,
            color: color
        }, className: className }, getAttributes(rest));
    return React.createElement(MuiChip, __assign({}, muiConfigC));
};
export { C as Chip };
